module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture24-4b098bf5d2964514777e198c63def98a.jpg";